@if (cookieConsent.ready() && !cookieConsent.hasDecision() && !cookieConsent.preferencesOpen()) {
  <aside class="cookie-banner" aria-label="Cookie consent">
    <div class="cookie-banner__copy">
      <strong>We value your privacy</strong>
      <p>
        Hytec uses essential storage to keep the site secure and optional analytics to improve your
        experience. Read our <a routerLink="/privacy-policy">Privacy Policy</a> and
        <a routerLink="/terms-and-conditions">Terms and Conditions</a>.
      </p>
    </div>
    <div class="cookie-banner__actions">
      <button
        type="button"
        class="cookie-button cookie-button--outline"
        (click)="openPreferences()"
      >
        Manage Preferences
      </button>
      <button
        type="button"
        class="cookie-button cookie-button--muted"
        (click)="cookieConsent.rejectNonEssential()"
      >
        Reject Non-Essential
      </button>
      <button
        type="button"
        class="cookie-button cookie-button--primary"
        (click)="cookieConsent.acceptAll()"
      >
        Accept All
      </button>
    </div>
  </aside>
}

@if (cookieConsent.ready() && cookieConsent.preferencesOpen()) {
  <div class="cookie-modal-backdrop" role="presentation" (click)="cookieConsent.closePreferences()">
    <section
      class="cookie-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cookie-preferences-title"
      (click)="$event.stopPropagation()"
    >
      <header class="cookie-modal__header">
        <div>
          <p class="cookie-modal__eyebrow">Privacy choices</p>
          <h2 id="cookie-preferences-title">Cookie Preferences</h2>
        </div>
        <button
          type="button"
          class="cookie-modal__close"
          aria-label="Close cookie preferences"
          (click)="cookieConsent.closePreferences()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </header>

      <p class="cookie-modal__intro">
        Choose which optional storage categories you allow. Essential storage is always active
        because it supports security, navigation, and basic site functionality.
      </p>

      <div class="cookie-category">
        <div>
          <h3>Essential</h3>
          <p>Required for the site to function. These preferences cannot be disabled.</p>
        </div>
        <span class="cookie-category__status">Always on</span>
      </div>

      <label class="cookie-category cookie-category--toggle">
        <span>
          <h3>Analytics</h3>
          <p>Optional measurement that helps us understand site usage and improve content.</p>
        </span>
        <input
          type="checkbox"
          [ngModel]="cookieConsent.preferencesAnalytics()"
          (ngModelChange)="cookieConsent.setPreferencesAnalytics($event)"
        />
      </label>

      <footer class="cookie-modal__actions">
        <button
          type="button"
          class="cookie-button cookie-button--muted"
          (click)="cookieConsent.rejectNonEssential()"
        >
          Reject Non-Essential
        </button>
        <button
          type="button"
          class="cookie-button cookie-button--primary"
          (click)="savePreferences()"
        >
          Save Preferences
        </button>
      </footer>
    </section>
  </div>
}
